import React from "react";
import { styled } from "@mui/material/styles";
import { Switch, SwitchProps } from "@mui/material";
import { Theme as MuiTheme } from "@mui/material/styles";
import { useLSContext } from "../Context/useLSContext";

export const IOSSwitch: React.FC<SwitchProps> = (props) => {
    const { factor } = useLSContext();
    
    const StyledSwitch = styled(Switch)(({ theme }: { theme: MuiTheme }) => ({
        width: 38 * factor,
        height: 22 * factor,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2 * factor,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: `translateX(${16 * factor}px)`,
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: 'primary.main',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: 'primary.main',
                border: `${6 * factor}px solid #fff`,
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: 'lightgrey'
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 18 * factor,
            height: 18 * factor,
        },
        '& .MuiSwitch-track': {
            borderRadius: (22 * factor) / 2,
            backgroundColor: 'lightgrey',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
            ...theme.applyStyles('dark', {
                backgroundColor: '#39393D',
            }),
        },
    }));

    return <StyledSwitch {...props} />;
};